// extracted by mini-css-extract-plugin
module.exports = {"root":"sellers_root__2wHzw","header":"sellers_header__XhA0e","footer":"sellers_footer__2W7gQ","title":"sellers_title__1dRQC","subtitle":"sellers_subtitle__2n9kK"};